// extracted by mini-css-extract-plugin
export default {"tab_link":"tab_tab_link__-hTan","active":"tab_active__NroGT","tab_list":"tab_tab_list__LdDNv","tab_list_item":"tab_tab_list_item__tW1HW"};